(function ($, window, undefined) {
    'use strict';

    /**
	 * [Banner description]
	 * @param {[type]} selector [description]
	 * @param {[type]} options  [description]
	 */



    App.Banner = function (selector, options) {
        this.element = $(selector);

        this.config = $.extend({
            auto: true,
            pause: 10000,
            transition: 'horizontal', // fade, horizontal, vertical, kenburns, false
            speed: 1200, // Tempo de transição
            easing: 'linear', // easing da animação
            controls: true,
            prevText: 'Anterior',
            nextText: 'Proximo',
            hideOnEnd: true,
            pager: true,
            pagerClass: 'slider-pager',
            loop: true,
            captions: false,
            responsive: false,
            onSlideBefore: this.callOnSlideBefore.bind(this),
            onSlideAfter: this.callOnSlideAfter.bind(this)
        }, options);
    };




    

    App.Banner.prototype.init = function () {
        //this.element.slippry(this.config);
        
        
        $('#masterslider').masterslider({
            width: 1920,
            space: 0,
            layout: "fullscreen",
            fullwidth: true,
            autoHeight: true,
            autoplay:true,
            loop: true,
            centerControls: false,
            view: "basic",
            controls : {
            arrows : {autohide:true},
            bullets: { autohide: true}
                
            }
        });

        
        if ($('#masterslider').length) {
            
            $('#masterslider').on(MSSliderEvent.CHANGE_START, function (e) {
                
            });

            $('#masterslider').on(MSSliderEvent.INIT, function () {
                
                BackgroundCheck.init({
                    targets: document.querySelectorAll('.template-inicial header, .ms-sl-selected .ms-caption, .estado-change'),
                    images: document.querySelectorAll('.ms-sl-selected img'),
                    windowEvents: false
                });
            });

            $('#masterslider').on(MSSliderEvent.CHANGE_END, function () {
                
                BackgroundCheck.init({
                    targets: document.querySelectorAll('.template-inicial header, .ms-sl-selected .ms-caption, .estado-change'),
                    images: document.querySelectorAll('.ms-sl-selected img'),
                    windowEvents: false
                });
                BackgroundCheck.refresh();
            });

        }

    };


    /**
	 * [callOnSlideBefore description]
	 * @param  {[type]} e        [description]
	 * @param  {[type]} previous [description]
	 * @param  {[type]} current  [description]
	 * @return {[type]}          [description]
	 */
    App.Banner.prototype.callOnSlideBefore = function (e, previous, current) {
        if (this.onSlideBefore && typeof (this.onSlideBefore) === 'function') {
            this.onSlideBefore(e, previous, current);
        }
    };

    /**
	 * [callOnSlideAfter description]
	 * @param  {[type]} e        [description]
	 * @param  {[type]} previous [description]
	 * @param  {[type]} current  [description]
	 * @return {[type]}          [description]
	 */
    App.Banner.prototype.callOnSlideAfter = function (e, previous, current) {
        if (this.onSlideAfter && typeof (this.onSlideAfter) === 'function') {
            this.onSlideAfter(e, previous, current);
        }
    };

    /**
	 * [boxResize description]
	 * @return {[type]} [description]
	 */
    App.Banner.prototype.boxResize = function () {

        $('.box-inicial').css({
            height: $(window).height()
        });

        $('.slider-box').css({
            height: $(window).height(),
            width: '100%'
        });



    };



})(jQuery, window);



